// JP SABINI
// changes to handle footer accordion on medium size display - search for SABINI

class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.summaryIsEmpty = this.summaryToggle.textContent.trim().length == 0;

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    document.addEventListener('matchSmall', this.close.bind(this));
    document.addEventListener('unmatchSmall', this.open.bind(this));
  // JP SABINI - added to handle footer accordion on medium size display - BEGINNING
    document.addEventListener('matchMedium', this.close.bind(this));
    document.addEventListener('unmatchMedium', this.open.bind(this));
  // JP SABINI - added to handle footer accordion on medium size display - END

  // JP SABINI - added to handle footer accordion on medium size display - added !theme.config.mqlMedium
    if ((!theme.config.mqlMedium && !theme.config.mqlSmall) || this.summaryIsEmpty) {
      this.detailsContainer.setAttribute('open', true);

      if (this.summaryIsEmpty) {
        this.detailsContainer.setAttribute('empty', true);
      }
    }
    else {
      if (this.dataset.open == undefined) this.detailsContainer.removeAttribute('open');
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open();
  }

  open() {
    this.detailsContainer.setAttribute('open', true);
  }

  close() {
    theme.config.mqlSmall && !this.summaryIsEmpty && this.detailsContainer.removeAttribute('open');
  // JP SABINI - added to handle footer accordion on medium size display - BEGINNING
    theme.config.mqlMedium && !this.summaryIsEmpty && this.detailsContainer.removeAttribute('open');
  // JP SABINI - added to handle footer accordion on medium size display - END
  }
}

customElements.define('footer-accordion', FooterAccordion);